import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import FormCalendar from "../../../components/calendar/formCalendar";
import ShowTable from "../../../components/tables/showTable";

const MedicalTechnologySection = ({
  control,
  setValue,
  errors,
  disabledDates,
  data,
  getValues
}) => {
  const [tableData, setTableData] = useState([]);
  const today = new Date();
  const minDate = today;
  const maxDate = new Date(today.getFullYear(), 11, 31);

  const loadData = () => {
    // 2. Tecnología Médica
    const currentValues = getValues();

    if (
      !currentValues.preventive_maintenance_performed &&
      data.preventive_maintenance_date
    )
      setValue(
        "preventive_maintenance_performed",
        new Date(data.preventive_maintenance_date)
      );

    if (!currentValues.nextMaintenance && data.next_maintenance_date)
      setValue("nextMaintenance", new Date(data.next_maintenance_date));
  };

  const columns = [
    {
      field: "serie_number",
      header: "Serie",
      align: "center",
      sortable: true
    },
    {
      field: "equipment_name",
      header: "Equipo",
      align: "center",
      sortable: true
    },
    {
      field: "equipment_model",
      header: "Modelo",
      align: "center",
      frozen: true
    },
    {
      field: "healthOrMarketing",
      header: "Registro INVIMA",
      align: "center",
      frozen: true
    },
    {
      field: "main_technology",
      header: "Tipo de tecnología",
      align: "center",
      frozen: true
    },
    {
      field: "riskClassification",
      header: "Riesgo",
      align: "center",
      frozen: true
    },
    {
      field: "brand_name",
      header: "Marca",
      align: "center",
      frozen: true
    }
  ];

  useEffect(() => {
    if (!data) return;
    setTableData(data.biomedicalEquipments);
    loadData();
  }, [data]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0">
            Mantenimiento preventivo ejectutado:
          </p>
          <FormCalendar
            name="preventive_maintenance_performed"
            control={control}
            label=""
            defaultValue={null}
            formLabel=""
            error={errors.preventive_maintenance_performed}
            margin={"0"}
            disabledDates={disabledDates}
            // minDate={minDate}
            // maxDate={maxDate}
            disabled={data ? (data.state == 2 ? true : false) : false}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0">Próximo mantenimiento:</p>
          <FormCalendar
            name="nextMaintenance"
            control={control}
            label=""
            defaultValue={null}
            formLabel=""
            error={errors.nextMaintenance}
            margin={"0"}
            disabledDates={disabledDates}
            minDate={minDate}
            // maxDate={maxDate}
            disabled={data ? (data.state == 2 ? true : false) : false}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <ShowTable
            data={tableData}
            columns={columns}
            rows={5}
            showTooltips={true}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default MedicalTechnologySection;
